(function () {
  try {
  console.warn('[PreorderShip] JS ejecutado. Trazas detalladas: ?debug_preorder=1 en la URL o localStorage debug_preorder=1 + recarga.');
  const JSON_SEL = "[data-preorder-variant-dates]";
  const WRAPPER_SEL = "[data-preorder-notice-wrapper]";
  const TEXT_SEL = "[data-preorder-notice-text]";
  const PROP_SEL = "[data-preorder-property]";
  const FOOTNOTE_SEL = "[data-preorder-footnote]";
  const PRODUCT_ROOT_SEL =
    '[data-section-type="product"], [data-section-type="featured-product"]';
  let warnedPreorderAllNull = false;

  function getProductRootForForm(form) {
    return form && form.closest ? form.closest(PRODUCT_ROOT_SEL) : null;
  }

  /** JSON en raíz de sección (sobrevive a Product Customizer) o legacy dentro del form */
  function getPreorderJsonEl(form) {
    const root = getProductRootForForm(form);
    if (root) {
      const inRoot = root.querySelector(JSON_SEL);
      if (inRoot) return inRoot;
    }
    return form ? form.querySelector(JSON_SEL) : null;
  }

  function isDebug() {
    try {
      if (window.__DEBUG_PREORDER_SHIP__ === true) return true;
      if (typeof localStorage !== "undefined" && localStorage.getItem("debug_preorder") === "1") return true;
      if (typeof URLSearchParams !== "undefined") {
        const p = new URLSearchParams(window.location.search || "");
        if (p.get("debug_preorder") === "1") return true;
      }
    } catch (_) {}
    return false;
  }

  function d() {
    if (!isDebug()) return;
    const args = Array.prototype.slice.call(arguments);
    args.unshift("[PreorderShip]");
    console.warn.apply(console, args);
  }

  function parseMap(form) {
    const el = getPreorderJsonEl(form);
    if (!el) {
      d("parseMap: no hay nodo", JSON_SEL, "en raíz ni en form");
      return null;
    }
    const raw = el.textContent.trim();
    try {
      const map = JSON.parse(raw);
      d("parseMap: claves en mapa", Object.keys(map).length, "ej.", Object.keys(map).slice(0, 3));
      return map;
    } catch (err) {
      console.warn("[PreorderShip] JSON inválido en data-preorder-variant-dates:", err, "raw:", raw.slice(0, 200));
      return null;
    }
  }

  function isoToDate(iso) {
    if (!iso || typeof iso !== "string") return null;
    const s = iso.trim();
    if (!s) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return new Date(`${s}T12:00:00`);
    return new Date(s);
  }

  function formatDateForLocale(iso) {
    const d = isoToDate(iso);
    if (!d || Number.isNaN(d.getTime())) return "";
    const lang = document.documentElement.lang || "en";
    try {
      return new Intl.DateTimeFormat(lang, { dateStyle: "long" }).format(d);
    } catch {
      return new Intl.DateTimeFormat("en", { dateStyle: "long" }).format(d);
    }
  }

  function getVariantIdFromForm(form) {
    const idSelect =
      form.querySelector('select[name="id"]') || form.querySelector("[data-variant-select]");
    if (idSelect && idSelect.value) {
      d("getVariantIdFromForm: select", idSelect.tagName, "value=", idSelect.value);
      return String(idSelect.value);
    }
    const idInput = form.querySelector('input[name="id"]:not([disabled])');
    if (idInput && idInput.value) {
      d("getVariantIdFromForm: input name=id value=", idInput.value);
      return String(idInput.value);
    }
    d("getVariantIdFromForm: sin id (ni select ni input usable)");
    return "";
  }

  /** ?variant= en la URL (Stiletto hace replaceState); a veces el select name=id va desfasado. */
  function getVariantIdFromUrl() {
    try {
      const v = new URLSearchParams(window.location.search).get("variant");
      return v && String(v).trim() ? String(v).trim() : "";
    } catch (_) {
      return "";
    }
  }

  function getEffectiveVariantId(form, map) {
    const urlId = getVariantIdFromUrl();
    const formId = getVariantIdFromForm(form);
    if (map && urlId && Object.prototype.hasOwnProperty.call(map, urlId)) {
      if (formId && formId !== urlId) {
        d("getEffectiveVariantId: prioridad URL sobre select", urlId, "vs", formId);
      }
      return urlId;
    }
    if (map && formId && Object.prototype.hasOwnProperty.call(map, formId)) return formId;
    return urlId || formId;
  }

  function getPreorderCtaLabel(form) {
    const w = form.querySelector(WRAPPER_SEL);
    const raw = w && w.getAttribute("data-preorder-cta-label");
    return (raw && raw.trim()) || "Pre-order";
  }

  function setBuyButtonsPreorderMode(form, active, ctaLabel) {
    const footnote = form.querySelector(FOOTNOTE_SEL);
    form.querySelectorAll("[data-add-to-cart]").forEach(function (btn) {
      const textEl = btn.querySelector("[data-add-to-cart-text]");
      if (!textEl) return;
      if (active) {
        textEl.textContent = ctaLabel;
        btn.setAttribute("aria-label", ctaLabel);
      } else {
        const disabled = btn.hasAttribute("disabled") || btn.getAttribute("aria-disabled") === "true";
        const label = disabled
          ? btn.getAttribute("data-lang-sold-out") || ""
          : btn.getAttribute("data-lang-available") || "";
        if (label) {
          textEl.textContent = label;
          btn.setAttribute("aria-label", label);
        }
      }
    });
    if (footnote) {
      if (active) {
        footnote.removeAttribute("hidden");
        footnote.classList.remove("hidden");
      } else {
        footnote.setAttribute("hidden", "");
        footnote.classList.add("hidden");
      }
    }
  }

  function updateForm(form) {
    const wrapper = form.querySelector(WRAPPER_SEL);
    if (!wrapper) {
      setBuyButtonsPreorderMode(form, false);
      d("updateForm: sin wrapper", WRAPPER_SEL, "handle=", form.dataset && form.dataset.productHandle);
      return;
    }

    const map = parseMap(form);
    const variantId = getEffectiveVariantId(form, map);
    const iso = map && variantId ? map[variantId] : null;

    d("updateForm:", {
      handle: form.dataset && form.dataset.productHandle,
      variantId,
      iso,
      mapHasKey: map && variantId ? Object.prototype.hasOwnProperty.call(map, variantId) : null,
    });

    const textEl = wrapper.querySelector(TEXT_SEL);
    const prop = wrapper.querySelector(PROP_SEL);
    const template = wrapper.getAttribute("data-preorder-template") || "";

    if (!iso || iso === "null") {
      wrapper.classList.add("hidden");
      if (textEl) textEl.textContent = "";
      if (prop) {
        prop.value = "";
        prop.disabled = true;
      }
      setBuyButtonsPreorderMode(form, false);
      d("updateForm: oculto (sin fecha efectiva para esta variante)");
      return;
    }

    const formatted = formatDateForLocale(iso);
    const message = template.includes("{date}")
      ? template.replace(/\{date\}/g, formatted)
      : `${template} ${formatted}`.trim();

    wrapper.classList.remove("hidden");
    if (textEl) textEl.textContent = message;
    if (prop) {
      prop.value = formatted;
      prop.disabled = false;
    }
    setBuyButtonsPreorderMode(form, true, getPreorderCtaLabel(form));
    d("updateForm: visible, message=", message);
  }

  function initForm(form) {
    if (!getPreorderJsonEl(form)) return;
    if (!form.querySelector(WRAPPER_SEL)) return;
    if (form.dataset.preorderShipDateInit) return;
    form.dataset.preorderShipDateInit = "1";
    d("initForm: primera vez", form.dataset && form.dataset.productHandle);
    updateForm(form);
  }

  let loggedFirstScan = false;
  let warnedMissingPreorderDom = false;

  function scanDocumentForms() {
    const forms = document.querySelectorAll("form[data-product-form]");
    if (isDebug() && !loggedFirstScan) {
      loggedFirstScan = true;
      d("scanDocumentForms (1ª vez): N formularios =", forms.length);
      forms.forEach((form, i) => {
        d("  form[" + i + "] handle=", form.dataset && form.dataset.productHandle, "JSON?", !!getPreorderJsonEl(form));
      });
    }
    forms.forEach(initForm);

    if (forms.length && !warnedMissingPreorderDom) {
      const anyFormHasJson = Array.prototype.some.call(forms, function (f) {
        return !!getPreorderJsonEl(f);
      });
      if (!anyFormHasJson) {
        warnedMissingPreorderDom = true;
        console.warn(
          "[PreorderShip] Hay",
          forms.length,
          "formulario(s) [data-product-form] pero ninguno incluye data-preorder-variant-dates. El Liquid del tema en la TIENDA no coincide con tu código (publica/subida del tema) o falta {% render 'product-preorder-ship-date' %} en product-form."
        );
      }
    }

    if (!warnedPreorderAllNull && forms.length) {
      for (let i = 0; i < forms.length; i++) {
        const form = forms[i];
        const el = getPreorderJsonEl(form);
        if (!el) continue;
        try {
          const m = JSON.parse(el.textContent.trim());
          const anyReal = Object.keys(m).some(function (k) {
            const v = m[k];
            return v != null && v !== "null" && String(v).trim() !== "";
          });
          if (!anyReal) {
            warnedPreorderAllNull = true;
            const h = form.dataset && form.dataset.productHandle;
            console.warn(
              "[PreorderShip] Mapa de fechas vacío (todo null) para",
              h || "(sin handle)",
              "— Liquid no ve datos en custom.fecha_preorder. Revisa en Admin: definiciones en Producto y Variante, permiso Tienda online, y que este producto tenga fechas guardadas."
            );
          }
        } catch (_) {}
        break;
      }
    }
  }

  let scanScheduled = false;
  function scheduleScanDocumentForms() {
    if (scanScheduled) return;
    scanScheduled = true;
    requestAnimationFrame(() => {
      scanScheduled = false;
      scanDocumentForms();
    });
  }

  function onDelegatedChange(e) {
    const t = e.target;
    if (!t || typeof t.matches !== "function") return;

    const optionOrVariantIdChanged =
      t.matches('[name^="options"]') ||
      (t.tagName === "SELECT" && t.name === "id") ||
      (t.tagName === "INPUT" && t.name === "id");

    if (!optionOrVariantIdChanged) return;

    d("change detectado:", {
      tag: t.tagName,
      name: t.name,
      type: t.type,
      value: t.value,
    });

    const productRoot = t.closest(
      '[data-section-type="product"], [data-section-type="featured-product"]'
    );
    if (!productRoot) {
      d("FALLO: no hay ancestro data-section-type product|featured-product. Ancestros:", ancestorsSummary(t));
      return;
    }

    d("productRoot section-type=", productRoot.getAttribute("data-section-type"));

    const form = productRoot.querySelector("form[data-product-form]");
    if (!form) {
      d("FALLO: no hay form[data-product-form] dentro del productRoot");
      return;
    }
    if (!getPreorderJsonEl(form)) {
      d("FALLO: sin JSON preorder (ni en raíz de sección ni en form)", "handle=", form.dataset && form.dataset.productHandle);
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(() => updateForm(form));
    });
  }

  function ancestorsSummary(node, max) {
    max = max || 6;
    const names = [];
    let el = node;
    for (let i = 0; i < max && el; i++) {
      const id = el.id ? "#" + el.id : "";
      const st = el.getAttribute && el.getAttribute("data-section-type");
      const ds = st ? "[data-section-type=" + st + "]" : el.tagName + id;
      names.push(ds);
      el = el.parentElement;
    }
    return names.join(" > ");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }

  function onReady() {
    document.querySelectorAll(FOOTNOTE_SEL).forEach(function (el) {
      el.setAttribute("hidden", "");
      el.classList.add("hidden");
    });
    scanDocumentForms();
  }

  const observer = new MutationObserver(() => scheduleScanDocumentForms());
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("change", onDelegatedChange, false);

  /**
   * Apps como Product Customizer a veces actualizan la variante sin disparar change
   * en options[name^="options"]. Sondeamos el select name="id" del formulario.
   */
  const lastVariantByForm = new WeakMap();
  function pollPreorderForms() {
    if (!document.querySelector(JSON_SEL)) return;
    document.querySelectorAll("form[data-product-form]").forEach(function (form) {
      if (!getPreorderJsonEl(form)) return;
      const map = parseMap(form);
      const id = getEffectiveVariantId(form, map);
      if (!id) return;
      const prev = lastVariantByForm.get(form);
      if (prev === id) return;
      lastVariantByForm.set(form, id);
      if (prev !== undefined) {
        d("poll: variante cambió", prev, "→", id);
        updateForm(form);
      } else {
        updateForm(form);
      }
    });
  }
  setInterval(pollPreorderForms, 400);

  function refreshPreorderFromUrl() {
    document.querySelectorAll("form[data-product-form]").forEach(function (form) {
      if (getPreorderJsonEl(form) && form.querySelector(WRAPPER_SEL)) updateForm(form);
    });
  }
  window.addEventListener("popstate", refreshPreorderFromUrl);

  window.__preorderShipDate = {
    debug: function (on) {
      if (on) {
        try {
          localStorage.setItem("debug_preorder", "1");
        } catch (_) {}
        window.__DEBUG_PREORDER_SHIP__ = true;
      } else {
        try {
          localStorage.removeItem("debug_preorder");
        } catch (_) {}
        window.__DEBUG_PREORDER_SHIP__ = false;
      }
      console.log("[PreorderShip] debug =", !!on, "(recarga la página para ver todos los logs desde el inicio)");
    },
    refresh: function () {
      document.querySelectorAll("form[data-product-form]").forEach(function (form) {
        if (getPreorderJsonEl(form)) updateForm(form);
      });
    },
    state: function (formIndex) {
      formIndex = formIndex || 0;
      const form = document.querySelectorAll("form[data-product-form]")[formIndex];
      if (!form) return console.warn("[PreorderShip] no form index", formIndex);
      const map = parseMap(form);
      const variantId = getEffectiveVariantId(form, map);
      return {
        handle: form.dataset && form.dataset.productHandle,
        variantIdFromForm: getVariantIdFromForm(form),
        variantIdFromUrl: getVariantIdFromUrl(),
        variantId,
        map,
        iso: map && variantId ? map[variantId] : null,
      };
    },
  };

  if (isDebug()) {
    console.warn(
      "%c[PreorderShip] DEBUG detallado ON",
      "color:#060;font-weight:bold",
      "— cambia variante. Apaga: window.__preorderShipDate.debug(false)"
    );
  }
  } catch (err) {
    console.error("[PreorderShip] error fatal al ejecutar el script:", err);
  }
})();
